// extracted by mini-css-extract-plugin
export default {"pageContainer":"Landing_pageContainer__Vzw9L","placeholder":"Landing_placeholder__rE81m"};